import Shepherd from 'shepherd.js';

const tour = new Shepherd.Tour({
    defaultStepOptions: {
        scrollTo: true
    },
    styleVariables: {
        shepherdHeaderBackground: '#3C4A66',
        shepherdThemePrimary: '#3C4A66',
        shepherdThemeTextColor: '#3C4A66',
        useDropShadow: true
    }
});

export const buildSelectCompanyStep = (completeCallBack: Function) => ({
    id: 'step1',
    text:
        'Bienvenido al Panel de Smartway, aquí podrás seleccionar tu Empresa para comenzar a visualizar su información',
    attachTo: {
        element: '.company-step',
        on: 'bottom'
    },
    buttons: [
        {
            text: 'Siguiente',
            action: tour.next
        },
        {
            text: 'Terminar',
            action: () => {
                completeCallBack();
                tour.complete();
            }
        }
    ]
});

export const buildCenterMapStep = (completeCallBack: Function) => ({
    id: 'step9',
    text: 'Puedes restablecer el Zoom del mapa en todo momento.',
    attachTo: {
        element: '.centerMap-step',
        on: 'bottom'
    },
    buttons: [
        {
            text: 'Siguiente',
            action: tour.next
        },
        {
            text: 'Anterior',
            action: tour.back
        },
        {
            text: 'Terminar',
            action: () => {
                completeCallBack();
                tour.complete();
            }
        }
    ]
});

export const buildSelectVehiclesStep = (nextCallBack: Function, completeCallBack: Function) => ({
    id: 'step2',
    text: 'Con el Filtro de Vehículos podrás seleccionar qué vehículos deseas visualizar en el mapa',
    attachTo: {
        element: '.multipleselectvehicle-step',
        on: 'right'
    },
    buttons: [
        {
            text: 'Siguiente',
            action: () => {
                nextCallBack();
                tour.next();
            }
        },
        {
            text: 'Anterior',
            action: tour.back
        },
        {
            text: 'Terminar',
            action: () => {
                completeCallBack();
                tour.complete();
            }
        }
    ]
});

export const buildLabelStep = (completeCallBack: Function) => ({
    id: 'step3',
    text: 'Puedes ocultar y mostrar las etiquetas de tus vehículos en todo momento',
    attachTo: {
        element: '.label-step',
        on: 'bottom'
    },
    buttons: [
        {
            text: 'Siguiente',
            action: tour.next
        },
        {
            text: 'Anterior',
            action: tour.back
        },
        {
            text: 'Terminar',
            action: () => {
                completeCallBack();
                tour.complete();
            }
        }
    ]
});

export const buildHideShowMarkersStep = (completeCallBack: Function) => ({
    id: 'step10',
    text: 'Puedes ocultar y mostrar las marcas en todo momento',
    attachTo: {
        element: '.marker-step',
        on: 'bottom'
    },
    buttons: [
        {
            text: 'Siguiente',
            action: tour.next
        },
        {
            text: 'Anterior',
            action: tour.back
        },
        {
            text: 'Terminar',
            action: () => {
                completeCallBack();
                tour.complete();
            }
        }
    ]
});

export const buildGeoFenceStep = (completeCallBack: Function) => ({
    id: 'step4',
    text: 'Podrás gestionar tus Geocercas y Puntos de interés desde el Panel de Marcas',
    attachTo: {
        element: '.geofence-step',
        on: 'bottom'
    },
    buttons: [
        {
            text: 'Siguiente',
            action: tour.next
        },
        {
            text: 'Anterior',
            action: tour.back
        },
        {
            text: 'Terminar',
            action: () => {
                completeCallBack();
                tour.complete();
            }
        }
    ]
});

export const buildYesterDayStep = (backCallBack: Function, completeCallBack: Function) => ({
    id: 'step5',
    text:
        'Podrás visualizar el recorrido realizado por tus vehículos en un rango de tiempo específico, mediante los botónes Ayer y Hoy o ingresando un período específico mediante el botón Fecha',
    attachTo: {
        element: '.yesyerday-step',
        on: 'bottom'
    },
    buttons: [
        {
            text: 'Siguiente',
            action: tour.next
        },
        {
            text: 'Anterior',
            action: () => {
                backCallBack();
                tour.back();
            }
        },
        {
            text: 'Terminar',
            action: () => {
                completeCallBack();
                tour.complete();
            }
        }
    ]
});

export const buildFilterStep = (nextCallBack: Function, completeCallBack: Function) => ({
    id: 'step13',
    text: 'Aquí podrás gestionar distintas formas de filtrar y visualizar la información sobre el mapa',
    attachTo: {
        element: '.filter-step',
        on: 'right'
    },
    buttons: [
        {
            text: 'Siguiente',
            action: () => {
                nextCallBack();
                tour.next();
            }
        },
        {
            text: 'Anterior',
            action: tour.back
        },
        {
            text: 'Terminar',
            action: () => {
                completeCallBack();
                tour.complete();
            }
        }
    ]
});

export const buildFilterListStep = (nextCallBack: Function, backCallBack: Function, completeCallBack: Function) => ({
    id: 'step14',
    text:
        'Litora scelerisque habitant sollicitudin egestas nullam nostra leo potenti sapien ut erat augue ridiculus congue',
    attachTo: {
        element: '.filter-list-step',
        on: 'bottom'
    },
    buttons: [
        {
            text: 'Siguiente',
            action: () => {
                nextCallBack();
                tour.next();
            }
        },
        {
            text: 'Anterior',
            action: () => {
                backCallBack();
                tour.back();
            }
        },
        {
            text: 'Terminar',
            action: () => {
                completeCallBack();
                tour.complete();
            }
        }
    ]
});

export const buildStatsStep = (nextCallBack: Function, completeCallBack: Function) => ({
    id: 'step6',
    text: 'También puedes visualizar la evolución de las variables de tus vehículos mediante el Panel de Estadísticas',
    attachTo: {
        element: '.stats-step',
        on: 'top'
    },
    buttons: [
        {
            text: 'Siguiente',
            action: () => {
                nextCallBack();
                tour.next();
            }
        },
        {
            text: 'Anterior',
            action: tour.back
        },
        {
            text: 'Terminar',
            action: () => {
                completeCallBack();
                tour.complete();
            }
        }
    ]
});

export const buildStatsPanelStep = (nextCallBack: Function, backCallBack: Function, completeCallBack: Function) => ({
    id: 'step7',
    text: 'También puedes visualizar la evolución de las variables de tus vehículos mediante el Panel de Estadísticas',
    attachTo: {
        element: '.statsPanel-step',
        on: 'top'
    },
    buttons: [
        {
            text: 'Siguiente',
            action: () => {
                nextCallBack();
                tour.next();
            }
        },
        {
            text: 'Anterior',
            action: () => {
                backCallBack();
                tour.back();
            }
        },
        {
            text: 'Terminar',
            action: () => {
                completeCallBack();
                tour.complete();
            }
        }
    ]
});

export const buildUndoStep = (nextCallBack: Function, backCallBack: Function, completeCallBack: Function) => ({
    id: 'step12',
    text: 'Puedes restablecer los valores de la gráfica cuando se seleccione una porción de ellos.',
    attachTo: {
        element: '.undo-step',
        on: 'top'
    },
    buttons: [
        {
            text: 'Siguiente',
            action: () => {
                nextCallBack();
                tour.next();
            }
        },
        {
            text: 'Anterior',
            action: () => {
                backCallBack();
                tour.back();
            }
        },
        {
            text: 'Terminar',
            action: () => {
                completeCallBack();
                tour.complete();
            }
        }
    ],
    beforeShowPromise: () => new Promise<any>(resolve => setTimeout(resolve, 800))
});

export const buildStatsInfoPanelStep = (
    nextCallBack: Function,
    backCallBack: Function,
    completeCallBack: Function
) => ({
    id: 'step11',
    text: 'Puedes visualizar las estadísticas generales y compararlas con una selección de un período de tiempo.',
    attachTo: {
        element: '.statsPanelInfo-step',
        on: 'top'
    },
    buttons: [
        {
            text: 'Siguiente',
            action: () => {
                nextCallBack();
                tour.next();
            }
        },
        {
            text: 'Anterior',
            action: () => {
                backCallBack();
                tour.back();
            }
        },
        {
            text: 'Terminar',
            action: () => {
                completeCallBack();
                tour.complete();
            }
        }
    ]
});

export const buildPlayBackStep = (backCallBack: Function, completeCallBack: Function) => ({
    id: 'step8',
    text:
        'Para el período de tiempo seleccionado, podrás reproducir el recorrido de tus vehículos minuto a minuto y con diferentes velocidades.',
    attachTo: {
        element: '.playBack-step',
        on: 'right'
    },
    buttons: [
        {
            text: 'Anterior',
            action: () => {
                backCallBack();
                tour.back();
            }
        },
        {
            text: 'Terminar',
            action: () => {
                completeCallBack();
                tour.complete();
            }
        }
    ]
});

export { tour };
